import {ChangeDetectorRef, Component, ElementRef, forwardRef} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractAutocompleteInput} from "../abstract-autocomplete-input";
import {FUIOptionsService} from "../../../framework/options.service";
import {FUIEventsService} from "../../../../events/events.service";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIEditAutocompleteInputComponent),
            multi: true
        }
    ],
    selector: "fui-edit-autocomplete-input",
    styleUrls: ["./edit-autocomplete-input.component.scss"],
    templateUrl: "./edit-autocomplete-input.component.html"
})
export class FUIEditAutocompleteInputComponent extends FUIAbstractAutocompleteInput {
    constructor(changeDetectorRef: ChangeDetectorRef,
                elementRef: ElementRef,
                eventsService: FUIEventsService,
                optionsService: FUIOptionsService) {
        super(changeDetectorRef, elementRef, eventsService, optionsService);
    }
}
